import type React from 'react';
import type { ReactNode } from 'react';
import { Fragment } from 'react';
import { logError } from '@zg-rentals/log-error';

interface TabItemProps {
  tabTitle?: string; // tabTitle is an optional string prop
  children?: ReactNode; // children can be any valid React nodes
  className?: string; // className is an optional string prop for styling
}

const TabItem: React.FC<TabItemProps> = ({ tabTitle, children }) => {
  if (!tabTitle) {
    logError({ error: 'TabItem is missing tabTitle prop', errorType: 'TabItemError' });
  }
  return <Fragment>{children}</Fragment>;
};

export default TabItem;
